angular.module('unergie.main')
.factory('mapUtils', () => {
    // order map by keys
    const orderMap = (map) => {
        const validationArray = Array.from(Object.keys(map))
        validationArray.sort()
        validationArray.forEach((item) => {
            // mutates the object instead of recreating one
            const temp = map[item]
            delete map[item]
            map[item] = temp
        })
        return map
    }

    const hasDifference = (mapA, mapB, listField) => {
        return listField.some((field) => (_.get(mapA, field) !== _.get(mapB, field)))
    }

    const arePropsDefined = (obj, listField) => listField.every((field) => !_.isNil(_.get(obj, field)))

    return {
        arePropsDefined,
        hasDifference,
        orderMap,
    }
})
